import React from 'react';
import { TextInput } from 'ui-toolkit';
import { createOnChangeHandlerGenerator } from '../utilities/createOnChangeHandlerGenerator';
import { CdLabelCell } from '../CdLabelCell.styles';
import IHasItemDataProps from './IHasItemDataProps';
import IHasItemEventProps from './IHasItemEventProps';
import IItemProps from './IItemProps';
import SharedItemCells from './SharedItemCells';
import { ITaxOtherViewItem } from '../../../ui-toolkit/cdItems/interfaces/ICDViewItem';

interface ITaxProps
  extends IItemProps,
    IHasItemDataProps<ITaxOtherViewItem>,
    Required<IHasItemEventProps<ITaxOtherViewItem>> {}

const Tax: React.FC<ITaxProps> = (props) => {
  const { data, onChange, hasEditPermissions } = props;

  const generateDefaultOnChangeHandler = createOnChangeHandlerGenerator(data, onChange);
  const labelOnChange = generateDefaultOnChangeHandler('label');
  const payeeOnChange = generateDefaultOnChangeHandler('payee');
  return (
    <div className="tax">
      <SharedItemCells {...props} readOnly={!hasEditPermissions}>
        <CdLabelCell gridTemplateColumns={'1fr min-content 1fr'}>
          <TextInput
            onChange={labelOnChange}
            placeholder="Tax Other"
            value={data.label}
            readOnly={!hasEditPermissions}
            debounceOnValueChange
          />
          <span>to</span>
          <TextInput
            onChange={payeeOnChange}
            placeholder="Payee"
            value={data.payee}
            readOnly={!hasEditPermissions}
            debounceOnValueChange
          />
        </CdLabelCell>
      </SharedItemCells>
    </div>
  );
};

export default Tax;
